import React, { ChangeEvent, FunctionComponent } from 'react';
import { InputBaseComponentProps, TextField } from '@material-ui/core';
import NumberFormat from 'react-number-format';

type InputTextComponentProps = {
    disabled?: boolean;
    size: 'small';
    defaultValue?: string;
    className: string;
    id: string;
    fontSize: string;
    customInputProps?: string;
    inputProps?: string;
    disableUnderline?: boolean;
    multiline?: boolean;
    onChange: Function;
    variant?: string;
    value?: string | number;
    error?: boolean;
    inputType?: string;
    rows?: string | number;
};

const CurrencyFormat: FunctionComponent<InputBaseComponentProps> = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { inputRef, onChange, defaultValue, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange?.({
                    target: {
                        value: values.value,
                    },
                } as ChangeEvent<HTMLTextAreaElement | HTMLInputElement>);
            }}
            thousandSeparator
            isNumericString
            prefix="$"
            decimalScale={2}
            fixedDecimalScale
            allowNegative={false}
        />
    );
};

const NumericFormat: FunctionComponent<InputBaseComponentProps> = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { inputRef, onChange, defaultValue, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange?.({
                    target: {
                        value: values.value,
                    },
                } as ChangeEvent<HTMLTextAreaElement | HTMLInputElement>);
            }}
            thousandSeparator
            isNumericString
            fixedDecimalScale
            allowNegative={false}
        />
    );
};

const InputTextComponent: FunctionComponent<InputTextComponentProps> = (props) => {
    const {
        disabled = false,
        size,
        id,
        defaultValue,
        value,
        className,
        inputProps,
        multiline,
        inputType,
        error,
        rows,
    } = props;

    const setInputText = (e: { target: { value: React.SetStateAction<string> } }) => {
        props.onChange(e.target.value);
    };

    const setInputComponentType = (type: string | undefined) => {
        switch (type) {
            case 'currency':
                return CurrencyFormat;
            case 'number':
                return NumericFormat;
            default:
                return undefined;
        }
    };
    return (
        <TextField
            disabled={disabled}
            size={size}
            id={id}
            value={value ?? ''}
            defaultValue={defaultValue}
            className={className}
            InputProps={{
                classes: {
                    input: inputProps,
                },
                disableUnderline: !error,
                inputComponent: setInputComponentType(inputType),
            }}
            multiline={multiline ? true : false}
            onChange={setInputText}
            error={error}
            inputProps={{ maxLength: inputType === 'currency' ? 15 : 1000 }}
            rows={rows}
        />
    );
};
export default InputTextComponent;
